import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';
import { CustomSpinner } from './CustomSpinner';
import { getFallbackValue } from '../../utils/fallbackCalculations';
import { useRecoilValue } from 'recoil';
import { recentBlocksState } from '../../recoilState';

export const NetworkTileBlocks24h = ({ data, blockMetrics, diamondbackData, formatNumber, animate }) => {
  const recentBlocks = useRecoilValue(recentBlocksState);

  // Priority chain (matches canonicalMetrics.js):
  // 1. Diamondback rate-based extrapolation (86400/avgBlockTime) — most accurate when
  //    network deviates from 10-min target (e.g. 155 blocks when avgBlockTime=557s)
  // 2. Real-time blockMetrics (limited to ~144 from seed history; undercounts when fast)
  // 3. Generic fallback chain
  const dbAvgBlockTime = diamondbackData?.blockchainStats?.avgBlockTime;
  const blocks = (dbAvgBlockTime ? Math.round(86400 / dbAvgBlockTime) : null)
    || blockMetrics?.blocks24h
    || getFallbackValue('newBlocks24h', {
      recentBlocks,
      s091: data?.s091
    });

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue
        label="New Blocks 24h"
        value={blocks != null ? `${formatNumber(blocks, 0)} Blocks` : <CustomSpinner />}
      />
    </ThemedFlex>
  );
};